import LinkToDocusaurus from '../LinkToDocusaurus'
import { monitorResults } from '../../docs-routes'

const LinkToMonitorResultsDoc = () =>
  <LinkToDocusaurus path={monitorResults}>
    Learn more about Monitor Results
  </LinkToDocusaurus>

export default LinkToMonitorResultsDoc
